export enum FormMethod {
  Get = 'get',
  Post = 'post'
}
